var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBrowse = function SvgBrowse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242.768,
    height: 296.453,
    viewBox: "0 0 242.768 296.453",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_content_structure_79gj",
    transform: "translate(-7.015 -40.499)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_752",
    "data-name": "Rectangle 752",
    width: 57.621,
    height: 51.162,
    transform: "translate(7.015 54.711)",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_753",
    "data-name": "Rectangle 753",
    width: 57.621,
    height: 51.162,
    transform: "translate(7.015 146.802)",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_754",
    "data-name": "Rectangle 754",
    width: 57.621,
    height: 51.162,
    transform: "translate(192.163 54.711)",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_755",
    "data-name": "Rectangle 755",
    width: 57.621,
    height: 51.162,
    transform: "translate(192.163 146.802)",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_756",
    "data-name": "Rectangle 756",
    width: 57.621,
    height: 51.162,
    transform: "translate(100.243 54.711)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_757",
    "data-name": "Rectangle 757",
    width: 57.621,
    height: 51.162,
    transform: "translate(100.243 146.802)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M460.59,264.986l-37.225-.843c4.458-14.425,5.419-28.158.924-40.813l37.225.843A81.5,81.5,0,0,0,460.59,264.986Z",
    transform: "translate(-312.663 -163.717)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_758",
    "data-name": "Rectangle 758",
    width: 0.897,
    height: 19.29,
    transform: "translate(120.407 68.113) rotate(-88.703)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_759",
    "data-name": "Rectangle 759",
    width: 0.897,
    height: 19.29,
    transform: "translate(120.326 71.701) rotate(-88.703)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_760",
    "data-name": "Rectangle 760",
    width: 0.897,
    height: 19.29,
    transform: "translate(120.244 75.289) rotate(-88.703)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_761",
    "data-name": "Rectangle 761",
    width: 0.897,
    height: 19.29,
    transform: "translate(120.163 78.877) rotate(-88.703)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_762",
    "data-name": "Rectangle 762",
    width: 0.897,
    height: 19.29,
    transform: "translate(120.082 82.465) rotate(-88.703)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_763",
    "data-name": "Rectangle 763",
    width: 0.897,
    height: 19.29,
    transform: "translate(120.001 86.053) rotate(-88.703)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_764",
    "data-name": "Rectangle 764",
    width: 0.897,
    height: 19.29,
    transform: "translate(119.92 89.641) rotate(-88.703)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_765",
    "data-name": "Rectangle 765",
    width: 0.897,
    height: 19.29,
    transform: "translate(119.838 93.228) rotate(-88.703)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_180",
    "data-name": "Ellipse 180",
    cx: 10.801,
    cy: 10.801,
    r: 10.801,
    transform: "translate(147.8 40.499)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M324.583,106.751l-4.091-5,.643-.526,3.387,4.14,5.918-8.68.686.468Z",
    transform: "translate(-166.367 -50.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M481.411,604.914,450.077,584.8c11.321-9.99,19.3-21.211,22.053-34.354l31.334,20.114a81.5,81.5,0,0,0-22.053,34.354Z",
    transform: "translate(-326.529 -333.523)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_766",
    "data-name": "Rectangle 766",
    width: 0.897,
    height: 19.29,
    transform: "translate(148.668 228.755) rotate(-57.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_767",
    "data-name": "Rectangle 767",
    width: 0.897,
    height: 19.29,
    transform: "translate(146.73 231.775) rotate(-57.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_768",
    "data-name": "Rectangle 768",
    width: 0.897,
    height: 19.29,
    transform: "translate(144.791 234.795) rotate(-57.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_769",
    "data-name": "Rectangle 769",
    width: 0.897,
    height: 19.29,
    transform: "translate(142.852 237.815) rotate(-57.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_770",
    "data-name": "Rectangle 770",
    width: 0.897,
    height: 19.29,
    transform: "translate(140.913 240.835) rotate(-57.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_771",
    "data-name": "Rectangle 771",
    width: 0.897,
    height: 19.29,
    transform: "translate(138.974 243.855) rotate(-57.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_772",
    "data-name": "Rectangle 772",
    width: 0.897,
    height: 19.29,
    transform: "translate(137.036 246.875) rotate(-57.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_773",
    "data-name": "Rectangle 773",
    width: 0.897,
    height: 19.29,
    transform: "translate(135.097 249.896) rotate(-57.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M376.664,777.97,384.49,762.8c14.443,2.376,16.992,1.89,29.612.252l3.356,16.462a181.863,181.863,0,0,0-40.794-1.545Z",
    transform: "translate(-288.42 -443.756)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M251.127,680.078l-.245-8.528.9.034.245,8.528Z",
    transform: "translate(-130.232 -348.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M243.67,679.8l-.246-8.528.9.034.245,8.528Z",
    transform: "translate(-126.361 -348.453)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M236.212,679.513l-.245-8.528.9.034.246,8.528Z",
    transform: "translate(-122.49 -348.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_774",
    "data-name": "Rectangle 774",
    width: 8.535,
    height: 0.897,
    transform: "translate(110.136 331.073) rotate(-87.83)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_775",
    "data-name": "Rectangle 775",
    width: 8.535,
    height: 0.897,
    transform: "translate(106.55 330.937) rotate(-87.83)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M214.1,678.665l.892-8.528.9.034L215,678.7Z",
    transform: "translate(-111.142 -347.866)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M206.647,678.383l.892-8.528.9.034-.892,8.528Z",
    transform: "translate(-107.27 -347.72)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M199.19,678.1l.892-8.528.9.034-.892,8.528Z",
    transform: "translate(-103.399 -347.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M493.017,519.886l.568,5.685s-4.548,16.485,2.274,15.348,4.548-15.348,4.548-15.348l-1.137-4.548Z",
    transform: "translate(-348.343 -317.659)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M636.942,521.068l-.568,5.685s4.548,16.485-2.274,15.348-4.548-15.348-4.548-15.348l1.137-4.548Z",
    transform: "translate(-419.505 -318.273)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M332.686,643.291l-1.705,11.937,11.938-1.137-1.706-11.937Z",
    transform: "translate(-171.812 -333.34)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M454.693,643.291l1.705,11.937-11.938-1.137,1.706-11.937Z",
    transform: "translate(-230.718 -333.34)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M522.194,504.793s-2.842,1.137,0,44.34l1.137,70.489H534.7l4.548-62.531L545.5,519l17.622,49.456,14.212,52.867,11.369-2.842-14.78-67.647s2.842-39.224-7.39-46.045S522.194,504.793,522.194,504.793Z",
    transform: "translate(-363.309 -308.251)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M511.028,755.162s-.236-5.17-1.255-5.427-8.409,6-8.409,6-7.958-1.137-7.39,7.39,11.938,5.685,11.938,5.685,2.274,5.116,6.822,5.116,11.369,0,11.938-3.411-2.842-18.759-3.979-18.191-3.979,0-3.979,0Z",
    transform: "translate(-349.301 -436.97)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M642.337,755.162s.236-5.17,1.255-5.427,8.409,6,8.409,6,7.958-1.137,7.39,7.39-11.937,5.685-11.937,5.685-2.274,5.116-6.822,5.116-11.369,0-11.938-3.411,2.842-18.759,3.979-18.191,3.979,0,3.979,0Z",
    transform: "translate(-419.216 -436.97)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_182",
    "data-name": "Ellipse 182",
    cx: 10.801,
    cy: 10.801,
    r: 10.801,
    transform: "translate(170.254 88.534)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M570.3,309.476s.568,15.348,3.411,17.054-17.054,0-17.054,0l2.274-13.075Z",
    transform: "translate(-381.854 -208.436)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M553.936,338.286s-10.232-5.116-19.9-1.705-14.78,7.39-14.78,7.39l6.253,32.971s-11.937,43.2-8.527,44.34,43.772-3.411,47.751,0,3.979-3.979,3.979-3.979-5.685-14.212-4.548-26.149,1.137-15.917,1.137-15.917l6.253-26.717Z",
    transform: "translate(-360.943 -221.897)",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M509.787,353.213h-3.979s-6.253,3.979-6.253,9.664-5.685,36.95-5.685,36.95l-3.41,35.245,9.664,1.705,8.527-46.614,6.253-12.506Z",
    transform: "translate(-347.492 -231.14)",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M608.667,362.67h10.8s3.411,3.411,5.116,11.369,3.411,39.224,3.411,39.224l-1.137,28.423h-8.527l-1.137-36.95-5.685-23.875Z",
    transform: "translate(-408.853 -236.049)",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M547.351,288.924l2.286,5.842c.937,2.394,2.01,4.955,4.206,6.291,2.712,1.649,6.333.845,8.956-.942a13.985,13.985,0,0,0-6.295-25.454l-.109,1.955-2.4-2.011a2.332,2.332,0,0,1-3.626.513c.63,1.306-.1,2.9-1.148,3.9-1.29,1.23-4.982,2.707-4.828,4.9C544.5,285.39,546.756,287.4,547.351,288.924Z",
    transform: "translate(-375.487 -190.334)",
    fill: "#2f2e41"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBrowse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/browse.bf076956.svg";
export { ForwardRef as ReactComponent };